const s = {
  name: "CreditCardLock",
  dimensions: { width: 40, height: 33 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 33" style="enable-background:new 0 0 40 33;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17,21H5v-2h12V21z"/>
		<path class="st0" d="M29,25v4h2v-4H29z"/>
		<path class="st0" d="M36,25.9c2.3-0.5,4-2.5,4-4.9V5c0-2.8-2.2-5-5-5H5C2.2,0,0,2.2,0,5v16c0,2.8,2.2,5,5,5h19v7h12V25.9z M5,2h30
			c1.7,0,3,1.3,3,3H2C2,3.3,3.3,2,5,2z M2,10V7h36v3H2z M2,12h36v9c0,1.3-0.8,2.4-2,2.8V21h-2v-1c0-2.2-1.8-4-4-4s-4,1.8-4,4v1h-2v3
			H5c-1.7,0-3-1.3-3-3V12z M32,20v1h-4v-1c0-1.1,0.9-2,2-2S32,18.9,32,20z M26,31v-8h8v8H26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CreditCardLock
};
